import { Add, Delete } from '@mui/icons-material';
import { Box, Grid, IconButton, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import * as Constant from 'common/Constant';
import moment from 'moment-timezone';
import { useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { v4 as uuid } from 'uuid';
import LaserDialog from '../laserDialog';

const LaserList = ({ slcStartDate, slcEndDate }) => {
  const [creationOpen, setCreationOpen] = useState(false);
  const { control, setValue, getValues } = useFormContext();
  const { fields, remove } = useFieldArray({
    control,
    keyName: Constant.DEFAULT_REACT_HOOK_FIELD_ID,
    name: 'laserDTOs'
  });
  const [cloneData, setCloneData] = useState({});

  const handleCreationClose = (data) => {
    if (data) {
      let existing = getValues('laserDTOs');
      if (!existing) {
        existing = [];
      }
      existing.push(data);
      setValue('laserDTOs', existing);
    }
    setCreationOpen(false);
  };

  const handleCreationOpen = (data) => {
    data.personIdentifierName1 = 'First Name';
    data.personIdentifierName2 = 'Last Name';
    data.personIdentifierName3 = 'Medical ID';
    setCloneData(data);
    setCreationOpen(true);
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        style={{ minWidth: '500px' }}>
        <LaserDialog
          open={creationOpen}
          onClose={handleCreationClose}
          target={cloneData}
          slcStartDate={slcStartDate}
          slcEndDate={slcEndDate}
        />

        {fields && Array.isArray(fields) && fields.length > 0 ? (
          fields.map((item, index) => (
            <Grid container key={`laser-${index}`}>
              <Grid item xs={2}>
                <TextField
                  id={'readonly-personid-' + index}
                  key={'key-' + uuid()}
                  label="Person Id"
                  InputProps={{ readOnly: true }}
                  defaultValue={item.personId}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  id={'readonly-personIdentifierName1-' + index}
                  key={'key-' + uuid()}
                  label="First Name"
                  InputProps={{ readOnly: true }}
                  defaultValue={item.personIdentifierValue1}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  id={'readonly-personIdentifierName2-' + index}
                  key={'key-' + uuid()}
                  label="Last Name"
                  InputProps={{ readOnly: true }}
                  defaultValue={item.personIdentifierValue2}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  id={'readonly-personIdentifierName3-' + index}
                  key={'key-' + uuid()}
                  label="Medical Id"
                  InputProps={{ readOnly: true }}
                  defaultValue={item.personIdentifierValue3}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  id={'readonly-laserAmount-' + index}
                  key={'key-' + uuid()}
                  label="Amount"
                  InputProps={{ readOnly: true }}
                  defaultValue={item.laserAmount}
                />
              </Grid>
              <Grid item xs={2}></Grid>
              <Grid item xs={2}>
                <TextField
                  id={'readonly-contractBasis-' + index}
                  key={'key-' + uuid()}
                  label="Contract Basis"
                  InputProps={{ readOnly: true }}
                  defaultValue={item.contractBasis}
                />
              </Grid>
              <Grid item xs={2}>
                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en">
                  <DatePicker
                    key={'key-' + uuid()}
                    id={'readonly-runInStartDate-' + index}
                    label="Run In Start Date"
                    disabled
                    inputFormat={Constant.FORMAT_DATE}
                    value={item.runInStartDate ? moment.utc(item.runInStartDate) : null}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={2}>
                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en">
                  <DatePicker
                    key={'key-' + uuid()}
                    id={'readonly-runInEndDate-' + index}
                    label="Run In End Date"
                    disabled
                    inputFormat={Constant.FORMAT_DATE}
                    value={item.runInEndDate ? moment.utc(item.runInEndDate) : null}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={2}>
                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en">
                  <DatePicker
                    key={'key-' + uuid()}
                    id={'readonly-runOutStartDate-' + index}
                    label="Run Out Start Date"
                    disabled
                    inputFormat={Constant.FORMAT_DATE}
                    value={item.runOutStartDate ? moment.utc(item.runOutStartDate) : null}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={2}>
                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en">
                  <DatePicker
                    key={'key-' + uuid()}
                    id={'readonly-runOutEndDate-' + index}
                    label="Run Out End Date"
                    disabled
                    inputFormat={Constant.FORMAT_DATE}
                    value={item.runOutEndDate ? moment.utc(item.runOutEndDate) : null}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={2}>
                <Box display="flex" justifyContent="flex-end">
                  {index === fields.length - 1 ? (
                    <IconButton
                      id={'action-add'}
                      key={'key-' + uuid()}
                      onClick={() =>
                        handleCreationOpen({
                          runOutEndDate: null,
                          runOutStartDate: null,
                          runInEndDate: null,
                          runInStartDate: null
                        })
                      }
                      title="Add New"
                      size="large">
                      <Add />
                    </IconButton>
                  ) : null}
                  <IconButton id={'action-delete-' + index} onClick={() => remove(index)} size="large">
                    <Delete />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
          ))
        ) : (
          <>
            <Grid container justifyContent="center" alignItems="center">
              <i>No data was found. Please click </i>
              <IconButton
                id={'action-add-no-data'}
                key={'key-' + uuid()}
                onClick={() =>
                  handleCreationOpen({
                    runOutEndDate: null,
                    runOutStartDate: null,
                    runInEndDate: null,
                    runInStartDate: null
                  })
                }
                title="Add New"
                size="large">
                <Add />
              </IconButton>
              <i> to create a new one</i>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default LaserList;
